// src/i18n/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// статические ресурсы
import en from './locales/en/common.json';
import pl from './locales/pl/common.json';
import uk from './locales/uk/common.json';

const SUPPORTED = ['en', 'pl', 'uk'];

function pickInitialLng() {
    // 1) localStorage
    const stored = localStorage.getItem('i18nextLng');
    if (stored) {
        const base = stored.split('-')[0].toLowerCase();
        if (SUPPORTED.includes(base)) return base;
    }
    // 2) браузер
    const nav = (navigator.language || 'en').split('-')[0].toLowerCase();
    return SUPPORTED.includes(nav) ? nav : 'en';
}

const initialLng = pickInitialLng();

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: { common: en },
            pl: { common: pl },
            uk: { common: uk },
        },
        lng: initialLng,          // стартовый язык
        fallbackLng: 'en',
        supportedLngs: SUPPORTED,
        ns: ['common'],
        defaultNS: 'common',
        interpolation: { escapeValue: false },
        react: { useSuspense: false },
        // помогают с кодами "en-US" -> "en"
        load: 'languageOnly',
        cleanCode: true,
        lowerCaseLng: true,
    });

// сохраняем выбор пользователя и проставляем <html lang="...">
i18n.on('languageChanged', (lng) => {
    const base = (lng || 'en').split('-')[0].toLowerCase();
    localStorage.setItem('i18nextLng', base);
    document.documentElement.lang = base;
});

export default i18n;
